import React from 'react';
import Layout from '../components/Layout';

function Archive() {
  // 文章数据
  const posts = [
    {
      id: 1,
      title: 'Understanding Portuguese Verb Conjugation Patterns',
      date: '2023-11-15',
      category: 'Research'
    },
    {
      id: 2,
      title: 'Building a NLP Model for Verb Recognition',
      date: '2023-10-22',
      category: 'Projects'
    },
    // 可以添加更多文章
  ];

  return (
    <Layout>
      <div className="max-w-2xl mx-auto">
        <h2 className="text-xl font-semibold mb-4">Archive</h2>

        <div className="divide-y divide-gray-200">
          {posts.map((post) => (
            <div key={post.id} className="py-3">
              <div className="flex justify-between items-center mb-1">
                <h3 className="font-medium">{post.title}</h3>
                <span className="text-xs text-gray-500">{post.date}</span>
              </div>
              <span className="text-xs bg-gray-200 px-2 py-1 rounded">
                {post.category}
              </span>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}

export default Archive;